const BASE = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api'}/flags`;

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('authToken');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

export type FeatureFlags = Record<string, boolean>;

async function getSystemFlags(): Promise<FeatureFlags> {
  try {
    const res = await fetch(`${BASE}/system`);
    if (!res.ok) return {};
    return res.json();
  } catch {
    return {};
  }
}

export async function getMyFlags(): Promise<FeatureFlags> {
  const [systemFlags, userFlags] = await Promise.all([
    getSystemFlags(),
    (async () => {
      const res = await fetch(`${BASE}/me`, { headers: authHeaders() });
      if (!res.ok) return {} as FeatureFlags;
      return res.json() as Promise<FeatureFlags>;
    })(),
  ]);
  // system flags are the base; per-user flags override them
  return { ...systemFlags, ...userFlags };
}

export async function setFlag(key: string, isEnabled: boolean): Promise<void> {
  const res = await fetch(`${BASE}/${key}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify({ is_enabled: isEnabled }),
  });
  if (!res.ok) throw new Error(`Failed to set flag ${key}`);
}
